import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: {},
};

export const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload || {};
    },
    logout: (state) => {
      state.permissions = {};
    },
  },
});

export const { 
  setPermissions, 
  logout, 
} = permissionSlice.actions;
export default permissionSlice.reducer;